import { Toaster as Sonner } from 'sonner'
import './sonner.scss'

export function Toaster() {
  return (
    <Sonner
      position="bottom-right"
      closeButton={false}
      duration={4000}
      gap={8}
      offset={{ bottom: 122, right: 50 }}
      toastOptions={{
        classNames: {
          toast:
            'c-snackbar min-h-12 w-[344px] px-4 py-3 bg-surface-medium-inverse text-content-highest-emphasis-inverse border-none rounded-sm text-sm leading-5 shadow-[0px_0.25px_3px_rgba(0,0,0,0.04),0px_2.75px_9px_rgba(0,0,0,0.19)]',
          error: 'c-snackbar--error bg-error-main',
          actionButton:
            'c-snackbar__action bg-transparent text-primary-light border-none p-0 m-0 text-sm font-medium cursor-pointer',
        },
      }}
    />
  )
}
